<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const cookieBannerStore = useCookieBannerStore();
const { isAcceptAllEnabled } = storeToRefs(cookieBannerStore);
</script>

<template>
    <div class="flex w-full flex-col justify-end gap-2 sm:flex-row">
        
<FormKitLazyProvider config-file="true">
<CookieBannerModal>
            <template #trigger>
                <FormKit
                    type="button"
                    :classes="{
                        input: 'w-full font-bold non-italic leading-normal text-md',
                        outer: 'w-full sm:max-w-fit',
                    }"
                >
                    {{ $t('cookie.banner.configureButton') }}
                </FormKit>
            </template>
        </CookieBannerModal>
        <FormKit
            type="button"
            :classes="{
                input: 'w-full font-bold non-italic leading-normal text-md',
                outer: 'w-full sm:max-w-fit',
            }"
            @click="cookieBannerStore.denyAll()"
        >
            {{ $t('cookie.banner.denyAllButton') }}
        </FormKit>
        <FormKit
            v-if="isAcceptAllEnabled"
            type="submit"
            :classes="{
                input: 'w-full font-bold non-italic leading-normal text-md',
                outer: 'w-full sm:max-w-fit',
            }"
            @click="cookieBannerStore.acceptAll()"
        >
            {{ $t('cookie.banner.allowAllButton') }}
        </FormKit>
</FormKitLazyProvider>

    </div>
</template>
